import Grid from "@mui/material/Grid"
import { t } from "i18next"
import type { AnySceneObjectT } from "tweenly"
import { useAppSelector } from "../../../../hooks/useRedux"
import { TIMELINE_ROW } from "../../../../style/sizing"
import EmptyPanel from "../../../common/EmptyPanel"
import { TimelineRowWrapper } from "./TimelineRowWrapper"

interface Props {
    objects: AnySceneObjectT[]
    timelineRowWidth: number
    isHidingObject: boolean
    isLockingObject: boolean
    isParentTicker?: boolean
}

const TimelineRows = ({
    objects,
    timelineRowWidth,
    isHidingObject,
    isLockingObject,
    isParentTicker = false,
}: Props) => {
    // a boolean instead of the whole editor slice
    const rowsExpanded: boolean = useAppSelector(
        (state) => state.editor.value.settings.timelineRowsExpanded
    )

    const timelineRowAreaWidth: number = TIMELINE_ROW.headingWidth
    const timelineAreaWidth = timelineRowWidth + timelineRowAreaWidth

    if (!objects || objects.length === 0)
        return (
            <EmptyPanel
                title={t("editor:emptyPanel.timelineRows.title")}
                subtitle={t("editor:emptyPanel.timelineRows.subtitle")}
            />
        )
    else
        return (
            <Grid
                py={0}
                sx={{
                    width: timelineAreaWidth + "px",
                    marginBottom: TIMELINE_ROW.paddingBottom,
                }}
            >
                {objects.map((object: AnySceneObjectT, index: number) => (
                    <TimelineRowWrapper
                        key={object.id}
                        object={object}
                        index={index}
                        timelineRowWidth={timelineRowWidth}
                        isHidingObject={isHidingObject}
                        isLockingObject={isLockingObject}
                        rowsExpanded={rowsExpanded}
                        timelineAreaWidth={timelineAreaWidth}
                        isParentTicker={isParentTicker}
                    />
                ))}
            </Grid>
        )
}

export default TimelineRows
